import { thai } from './thai'
import { english } from './english'
import { chinese } from './chinese'

export const translations = {
  th: thai,
  en: english,
  zh: chinese
}

export const languageOptions = [
  { id: 'th', label: 'ไทย' },
  { id: 'en', label: 'English' },
  { id: 'zh', label: '中文' }
]

export const getTranslation = (language, key, defaultValue = key) => {
  return translations[language]?.[key] || defaultValue
}